import Cookie from "js-cookie";

class ConsentCookie {
  constructor(name) {
    if (name !== String(name)) {
      throw new Error("Cookie name has not been specified");
    }

    this.name = name;
  }

  clear() {
    Cookie.remove(this.name);
  }

  get() {
    return Cookie.get(this.name);
  }

  set(value, expires) {
    Cookie.set(this.name, value, { expires, sameSite: "Strict" });
  }
}

function consentMaker() {
  let permCookie;
  let sessCookie;

  class Consent {
    constructor(permanentCookieName, sessionCookieName) {
      permCookie = new ConsentCookie(permanentCookieName);
      sessCookie = new ConsentCookie(sessionCookieName);

      Object.defineProperties(this, {
        permanentCookie: {
          get: () => permCookie
        },
        sessionCookie: {
          get: () => sessCookie
        }
      });
    }

    static get EXPIRY() {
      return 3600;
    }

    static get UNKNOWN() {
      return "unknown";
    }

    get hasSetConsent() {
      return this.permanentCookie.get() !== undefined;
    }

    get hasUnknownConsent() {
      return this.sessionCookie.get() === Consent.UNKNOWN;
    }

    get() {
      const consent = this.permanentCookie.get();

      return {
        consented: consent === "true",
        values: {
          perm: consent,
          sess: this.sessionCookie.get()
        }
      };
    }

    set(value) {
      const type = typeof value;

      if (type !== "boolean") {
        throw new Error(`Invalid parameter type: ${type}, expected boolean`);
      }

      this.permanentCookie.set(value.toString(), Consent.EXPIRY);
      this.sessionCookie.clear();
    }

    setUnknownConsent(force) {
      const { sessionCookie } = this;

      sessionCookie.clear();
      if (force) {
        sessionCookie.set(Consent.UNKNOWN);
      }
    }
  }

  return Consent
}

export default consentMaker();



// WEBPACK FOOTER //
// ./components/consent/Consent.js